var map = {
	"./API": 86037,
	"./API/": 86037,
	"./API/announcement": 82469,
	"./API/announcement.js": 82469,
	"./API/index": 86037,
	"./API/index.js": 86037,
	"./App": 30409,
	"./App.vue": 30409,
	"./assets/about/address-bj.png": 67814,
	"./assets/about/address-sh.png": 53949,
	"./assets/about/banner-11.jpg": 78603,
	"./assets/about/img-logo.png": 91422,
	"./assets/about/img-team.png": 35003,
	"./assets/about/line.png": 47481,
	"./assets/about/title-about.png": 35109,
	"./assets/about/title-contact.png": 2479,
	"./assets/about/title-join.png": 9963,
	"./assets/agreement/banner-13.jpg": 49475,
	"./assets/agreement/download.png": 12884,
	"./assets/agreement/eye.png": 39756,
	"./assets/announcement/banner-12.jpg": 93340,
	"./assets/collaboration/banner-10.jpg": 76370,
	"./assets/footer/GONGSHANGBANK.png": 23307,
	"./assets/footer/HUITIANFUJIJIN.png": 37807,
	"./assets/footer/LIANWANGQINGSUAN.png": 16366,
	"./assets/footer/SHANGHAIBANK.png": 1206,
	"./assets/footer/ZHONGGUOYINLIAN.png": 63824,
	"./assets/footer/ba.png": 46785,
	"./assets/footer/footer-110.png": 38375,
	"./assets/footer/footer-CUAM.png": 55056,
	"./assets/footer/footer-ICBKCNBJ.png": 63976,
	"./assets/footer/footer-ShanghaiBank.png": 94836,
	"./assets/footer/footer-Unionpay.png": 76205,
	"./assets/footer/footer-WLQS.png": 50604,
	"./assets/footer/footer-ZFQSXHHYZ.png": 66892,
	"./assets/footer/footer-ZFYWXKZ.png": 64909,
	"./assets/footer/footer-ZJGS.png": 35647,
	"./assets/footer/footer-adss@2x.png": 23004,
	"./assets/footer/footer-cfca@2x.png": 24738,
	"./assets/footer/footer-iso@2x.png": 24275,
	"./assets/footer/footer-logo.png": 99915,
	"./assets/footer/footer-pcidss@2x.png": 56251,
	"./assets/footer/footer-symantec@2x.png": 93176,
	"./assets/footer/footer-updss@2x.png": 58461,
	"./assets/footer/logo.png": 67401,
	"./assets/footer/wechat-er-code.png": 45725,
	"./assets/footer/wechat.png": 71478,
	"./assets/footer/weibo.png": 56871,
	"./assets/header/top-logo-black.png": 8127,
	"./assets/header/top-logo-white.png": 60357,
	"./assets/home/arrow-right.png": 39018,
	"./assets/home/bank-gray/ABC.png": 38171,
	"./assets/home/bank-gray/BOC.png": 12185,
	"./assets/home/bank-gray/BOS.png": 90152,
	"./assets/home/bank-gray/Bocom.png": 63953,
	"./assets/home/bank-gray/CCB.png": 11261,
	"./assets/home/bank-gray/CEB.png": 57110,
	"./assets/home/bank-gray/CGB.png": 99839,
	"./assets/home/bank-gray/CIB.png": 8872,
	"./assets/home/bank-gray/CITIC.png": 66827,
	"./assets/home/bank-gray/CMB.png": 1955,
	"./assets/home/bank-gray/CMBC.png": 6177,
	"./assets/home/bank-gray/HXB.png": 16586,
	"./assets/home/bank-gray/ICBC.png": 55306,
	"./assets/home/bank-gray/PAB.png": 42474,
	"./assets/home/bank-gray/PSBC.png": 45338,
	"./assets/home/bank-gray/SPDB.png": 78409,
	"./assets/home/bank/ABC.png": 74442,
	"./assets/home/bank/BOC.png": 61540,
	"./assets/home/bank/BOS.png": 59631,
	"./assets/home/bank/Bocom.png": 55040,
	"./assets/home/bank/CCB.png": 96389,
	"./assets/home/bank/CEB.png": 65414,
	"./assets/home/bank/CGB.png": 31245,
	"./assets/home/bank/CIB.png": 54045,
	"./assets/home/bank/CITIC.png": 85973,
	"./assets/home/bank/CMB.png": 60470,
	"./assets/home/bank/CMBC.png": 83848,
	"./assets/home/bank/HXB.png": 76053,
	"./assets/home/bank/ICBC.png": 65864,
	"./assets/home/bank/PAB.png": 72098,
	"./assets/home/bank/PSBC.png": 39762,
	"./assets/home/bank/SPDB.png": 61222,
	"./assets/home/banner-1.jpg": 56569,
	"./assets/home/banner-2.jpg": 5423,
	"./assets/home/banner-3.jpg": 59889,
	"./assets/home/banner-4.jpg": 81881,
	"./assets/home/banner-5.jpg": 32788,
	"./assets/home/bg-1.jpg": 74006,
	"./assets/home/bg-2.jpg": 72522,
	"./assets/home/folder-hover.png": 53393,
	"./assets/home/folder.png": 67008,
	"./assets/home/person1-hover.png": 35595,
	"./assets/home/person1.png": 84398,
	"./assets/home/person2-hover.png": 48122,
	"./assets/home/person2.png": 70165,
	"./assets/home/progress-1.png": 70762,
	"./assets/home/progress-2.png": 90871,
	"./assets/home/progress-3.png": 37729,
	"./assets/home/serve1.png": 79037,
	"./assets/home/serve2.png": 49311,
	"./assets/home/serve3.png": 20658,
	"./assets/home/serve4.png": 67661,
	"./assets/home/server-banner-1.jpg": 6040,
	"./assets/home/server-banner-2.jpg": 61775,
	"./assets/home/server-banner-3.jpg": 49621,
	"./assets/home/server-banner-4.jpg": 42162,
	"./assets/home/tips.png": 22154,
	"./assets/home/title-1.png": 34352,
	"./assets/home/title-2.png": 35846,
	"./assets/home/title-3.png": 41473,
	"./assets/home/title-4.png": 79723,
	"./assets/home/title-5.png": 51358,
	"./assets/home/title-6.png": 92713,
	"./assets/home/title-7.png": 89662,
	"./assets/home/title-8.png": 40892,
	"./assets/mobile/aboutUS/aboutUS_banner@2x.png": 3447,
	"./assets/mobile/aboutUS/aboutUS_location_beijing@2x.png": 44757,
	"./assets/mobile/aboutUS/aboutUS_location_shanghai@2x.png": 79119,
	"./assets/mobile/aboutUS/aboutUS_title@2x.png": 29866,
	"./assets/mobile/aboutUS/aboutUS_title_contactus@2x.png": 33551,
	"./assets/mobile/aboutUS/aboutUS_title_joinwhy@2x.png": 57918,
	"./assets/mobile/accountMiddle/account_banner@2x.png": 58307,
	"./assets/mobile/accountMiddle/account_membersolution@2x.png": 63745,
	"./assets/mobile/accountMiddle/account_middleadvantages@2x.png": 43576,
	"./assets/mobile/accountService/account-serviceadvantages@2x.png": 10662,
	"./assets/mobile/accountService/account-servicebanner@2x.png": 30290,
	"./assets/mobile/accountService/account-system@2x.png": 86647,
	"./assets/mobile/accountService/account-userinfo@2x.png": 25278,
	"./assets/mobile/agreement/agreementBanner@2x.png": 23869,
	"./assets/mobile/agreement/download@2x.png": 10211,
	"./assets/mobile/agreement/look@2x.png": 49236,
	"./assets/mobile/announcement/announcement-banner.png": 15323,
	"./assets/mobile/announcement/back.png": 94210,
	"./assets/mobile/announcement/next-disable.png": 28648,
	"./assets/mobile/announcement/next.png": 45023,
	"./assets/mobile/announcement/prev-disable.png": 61477,
	"./assets/mobile/announcement/prev.png": 39092,
	"./assets/mobile/bottom/dianhua@2x.png": 2094,
	"./assets/mobile/bottom/hezuo@2x.png": 40134,
	"./assets/mobile/home/banner-1.png": 60548,
	"./assets/mobile/home/banner-2.png": 51167,
	"./assets/mobile/home/banner-3.png": 75443,
	"./assets/mobile/home/banner-4.png": 94978,
	"./assets/mobile/home/banner-5.png": 24401,
	"./assets/mobile/home/navi-menu-close.png": 45657,
	"./assets/mobile/home/navi-menu.png": 46149,
	"./assets/mobile/home/partner.png": 1714,
	"./assets/mobile/home/product-1.png": 97671,
	"./assets/mobile/home/product-2.png": 51816,
	"./assets/mobile/home/product-3.png": 94933,
	"./assets/mobile/home/product-title.png": 47285,
	"./assets/mobile/home/progress.png": 31529,
	"./assets/mobile/home/serve-1.png": 90458,
	"./assets/mobile/home/serve-2.png": 37011,
	"./assets/mobile/home/serve-3.png": 51399,
	"./assets/mobile/home/serve-4.png": 34184,
	"./assets/mobile/home/serve-title.png": 64452,
	"./assets/mobile/home/solution-1.png": 31168,
	"./assets/mobile/home/solution-2.png": 75831,
	"./assets/mobile/home/solution-3.png": 94942,
	"./assets/mobile/home/solution-4.png": 77089,
	"./assets/mobile/home/solution-title.png": 90911,
	"./assets/mobile/payment/payment_bankcard@2x.png": 94342,
	"./assets/mobile/payment/payment_banner@2x.png": 15410,
	"./assets/mobile/payment/payment_businesswithhold@2x.png": 4165,
	"./assets/mobile/payment/payment_creditcard@2x.png": 14330,
	"./assets/mobile/payment/payment_creditcard_period@2x.png": 86850,
	"./assets/mobile/payment/payment_merchantcard@2x.png": 89010,
	"./assets/mobile/payment/payment_merchantonline@2x.png": 99075,
	"./assets/mobile/payment/payment_personcard@2x.png": 13897,
	"./assets/mobile/payment/payment_persononline@2x.png": 57567,
	"./assets/mobile/payment/payment_sinapayaccount@2x.png": 38070,
	"./assets/mobile/payment/payment_sinapayadvantages@2x.png": 83589,
	"./assets/mobile/payment/payment_title@2x.png": 18689,
	"./assets/mobile/payment/payment_title_receive@2x.png": 81518,
	"./assets/mobile/payment/payment_useguide@2x.png": 17381,
	"./assets/mobile/payment/payment_wxaliupop@2x.png": 69868,
	"./assets/mobile/solutions/account-management-1.png": 31937,
	"./assets/mobile/solutions/account-management-2.png": 27164,
	"./assets/mobile/solutions/account-management-3.png": 20579,
	"./assets/mobile/solutions/account-management-banner.png": 83814,
	"./assets/mobile/solutions/account-management-detail.png": 22020,
	"./assets/mobile/solutions/electronic-commerce-1.png": 75649,
	"./assets/mobile/solutions/electronic-commerce-2.png": 63637,
	"./assets/mobile/solutions/electronic-commerce-banner.png": 68355,
	"./assets/mobile/solutions/electronic-commerce-detail.png": 7523,
	"./assets/mobile/solutions/fund-payment-1.png": 54769,
	"./assets/mobile/solutions/fund-payment-2.png": 2766,
	"./assets/mobile/solutions/fund-payment-banner.png": 81475,
	"./assets/mobile/solutions/fund-payment-detail.png": 99025,
	"./assets/mobile/solutions/internet-finance-1.png": 39374,
	"./assets/mobile/solutions/internet-finance-2.png": 89781,
	"./assets/mobile/solutions/internet-finance-3.png": 46896,
	"./assets/mobile/solutions/internet-finance-banner.png": 88364,
	"./assets/mobile/solutions/internet-finance-detail.png": 29122,
	"./assets/productCenter/1.png": 98248,
	"./assets/productCenter/2.png": 81855,
	"./assets/productCenter/3.png": 38943,
	"./assets/productCenter/accountHubPlatform/1.png": 15090,
	"./assets/productCenter/accountHubPlatform/2.png": 32128,
	"./assets/productCenter/accountHubPlatform/3.png": 35243,
	"./assets/productCenter/accountHubPlatform/4.png": 62864,
	"./assets/productCenter/accountHubPlatform/5.png": 39500,
	"./assets/productCenter/accountHubPlatform/advantage-1.png": 22639,
	"./assets/productCenter/accountHubPlatform/advantage-2.png": 17040,
	"./assets/productCenter/accountHubPlatform/advantage-3.png": 25728,
	"./assets/productCenter/accountHubPlatform/advantage-4.png": 64078,
	"./assets/productCenter/accountHubPlatform/advantage-5.png": 65072,
	"./assets/productCenter/accountHubPlatform/advantage-6.png": 62752,
	"./assets/productCenter/accountHubPlatform/arrow-up-red.png": 85266,
	"./assets/productCenter/accountHubPlatform/banner-4.jpg": 3454,
	"./assets/productCenter/accountServices/advantage-1.png": 53070,
	"./assets/productCenter/accountServices/advantage-2.png": 5214,
	"./assets/productCenter/accountServices/advantage-3.png": 56958,
	"./assets/productCenter/accountServices/banner-5.jpg": 41032,
	"./assets/productCenter/accountServices/support-1.png": 95738,
	"./assets/productCenter/accountServices/support-2.png": 3941,
	"./assets/productCenter/accountServices/support-3.png": 69874,
	"./assets/productCenter/accountServices/support-4.png": 7568,
	"./assets/productCenter/accountServices/user-Info-1.png": 66926,
	"./assets/productCenter/accountServices/user-Info-2.png": 26186,
	"./assets/productCenter/accountServices/user-Info-3.png": 350,
	"./assets/productCenter/accountServices/user-Info-4.png": 96919,
	"./assets/productCenter/accountServices/user-Info-5.png": 61277,
	"./assets/productCenter/bg-shenqing.jpg": 20537,
	"./assets/productCenter/circle-arrow-right.png": 70439,
	"./assets/productCenter/standardPayment/advantage-1.png": 24714,
	"./assets/productCenter/standardPayment/advantage-2.png": 1682,
	"./assets/productCenter/standardPayment/advantage-3.png": 75045,
	"./assets/productCenter/standardPayment/banner-3.jpg": 72778,
	"./assets/productCenter/standardPayment/payment-1.png": 76953,
	"./assets/productCenter/standardPayment/payment-2.png": 65919,
	"./assets/productCenter/standardPayment/payment-3.png": 88009,
	"./assets/productCenter/standardPayment/receipt-1.png": 12160,
	"./assets/productCenter/standardPayment/receipt-2.png": 61918,
	"./assets/productCenter/standardPayment/receipt-3.png": 10066,
	"./assets/productCenter/standardPayment/receipt-4.png": 93980,
	"./assets/productCenter/standardPayment/receipt-5.png": 46037,
	"./assets/productCenter/standardPayment/receipt-6.png": 48150,
	"./assets/productCenter/standardPayment/receipt-7.png": 3401,
	"./assets/solutions/accountManagement/accountManagement.png": 27637,
	"./assets/solutions/accountManagement/authorization-1.jpg": 90936,
	"./assets/solutions/accountManagement/authorization-1.png": 93358,
	"./assets/solutions/accountManagement/authorization-2.jpg": 80981,
	"./assets/solutions/accountManagement/authorization-2.png": 29024,
	"./assets/solutions/accountManagement/banner-6.jpg": 23046,
	"./assets/solutions/accountManagement/strategy-1.png": 13661,
	"./assets/solutions/accountManagement/strategy-2.png": 83308,
	"./assets/solutions/accountManagement/strategy-3.png": 46084,
	"./assets/solutions/electronicCommerce/advantage-1.png": 25309,
	"./assets/solutions/electronicCommerce/advantage-2.png": 87701,
	"./assets/solutions/electronicCommerce/advantage-3.png": 60027,
	"./assets/solutions/electronicCommerce/advantage-4.png": 31636,
	"./assets/solutions/electronicCommerce/advantage-5.png": 45022,
	"./assets/solutions/electronicCommerce/banner-8.jpg": 52983,
	"./assets/solutions/electronicCommerce/electronicCommerce.png": 63037,
	"./assets/solutions/electronicCommerce/pain-point-1.png": 79776,
	"./assets/solutions/electronicCommerce/pain-point-2.png": 6364,
	"./assets/solutions/electronicCommerce/pain-point-3.png": 90777,
	"./assets/solutions/electronicCommerce/pain-point-4.png": 53342,
	"./assets/solutions/fundPayment/advantage-1.png": 91395,
	"./assets/solutions/fundPayment/advantage-2.png": 16529,
	"./assets/solutions/fundPayment/advantage-3.png": 85441,
	"./assets/solutions/fundPayment/advantage-4.png": 19172,
	"./assets/solutions/fundPayment/banner-9.jpg": 12072,
	"./assets/solutions/fundPayment/fundPayment.png": 58371,
	"./assets/solutions/fundPayment/pain-point-1.png": 32358,
	"./assets/solutions/fundPayment/pain-point-2.png": 61642,
	"./assets/solutions/fundPayment/pain-point-3.png": 88329,
	"./assets/solutions/internetFinance/banner-7.jpg": 52610,
	"./assets/solutions/internetFinance/internetFinance.png": 61209,
	"./assets/solutions/internetFinance/method-1.png": 97233,
	"./assets/solutions/internetFinance/method-2.png": 46674,
	"./assets/solutions/internetFinance/method-3.png": 60954,
	"./assets/solutions/internetFinance/progress-1.png": 75130,
	"./assets/solutions/internetFinance/progress-2.png": 55708,
	"./assets/solutions/internetFinance/progress-3.png": 71406,
	"./assets/solutions/internetFinance/progress-4.png": 17562,
	"./assets/solutions/internetFinance/service-1.png": 22879,
	"./assets/solutions/internetFinance/service-2.png": 58829,
	"./assets/solutions/internetFinance/service-3.png": 2602,
	"./assets/to-top-black.png": 88580,
	"./assets/to-top-white.png": 75589,
	"./components/Footer": 80173,
	"./components/Footer.vue": 80173,
	"./components/Header": 72145,
	"./components/Header.vue": 72145,
	"./components/ImgTitle": 72355,
	"./components/ImgTitle.vue": 72355,
	"./components/IntegrationGuide": 47321,
	"./components/IntegrationGuide.vue": 47321,
	"./components/StepNumber": 22339,
	"./components/StepNumber.vue": 22339,
	"./components/TopBanner": 99459,
	"./components/TopBanner.vue": 99459,
	"./components/mobile/MobileFooter": 30705,
	"./components/mobile/MobileFooter.vue": 30705,
	"./components/mobile/MobileHeader": 80143,
	"./components/mobile/MobileHeader.vue": 80143,
	"./layout/Mobile/MobileLayout": 42733,
	"./layout/Mobile/MobileLayout.vue": 42733,
	"./layout/WebLayout": 98911,
	"./layout/WebLayout.vue": 98911,
	"./main": 50866,
	"./main.js": 50866,
	"./pages/about/About": 66545,
	"./pages/about/About.vue": 66545,
	"./pages/about/components/JoinItem": 7098,
	"./pages/about/components/JoinItem.vue": 7098,
	"./pages/agreement/Agreement": 27161,
	"./pages/agreement/Agreement.vue": 27161,
	"./pages/announcement/AnnouncementDetail": 91230,
	"./pages/announcement/AnnouncementDetail.vue": 91230,
	"./pages/announcement/AnnouncementList": 46539,
	"./pages/announcement/AnnouncementList.vue": 46539,
	"./pages/collaboration/Collaboration": 33471,
	"./pages/collaboration/Collaboration.vue": 33471,
	"./pages/home/Home": 91366,
	"./pages/home/Home.vue": 91366,
	"./pages/home/LookBigImage": 81792,
	"./pages/home/LookBigImage.vue": 81792,
	"./pages/home/components/HomeCardItem": 53235,
	"./pages/home/components/HomeCardItem.vue": 53235,
	"./pages/home/components/HomeTips": 37567,
	"./pages/home/components/HomeTips.vue": 37567,
	"./pages/mobile/aboutus/AboutUS": 9478,
	"./pages/mobile/aboutus/AboutUS.vue": 9478,
	"./pages/mobile/accountService/AccountServiceProduct": 90509,
	"./pages/mobile/accountService/AccountServiceProduct.vue": 90509,
	"./pages/mobile/accountmiddle/AccountMiddleProduct": 37552,
	"./pages/mobile/accountmiddle/AccountMiddleProduct.vue": 37552,
	"./pages/mobile/agreement/AgreementList": 14792,
	"./pages/mobile/agreement/AgreementList.vue": 14792,
	"./pages/mobile/agreement/components/AgreementListItem": 62851,
	"./pages/mobile/agreement/components/AgreementListItem.vue": 62851,
	"./pages/mobile/announcement/AnnouncementDetail": 74307,
	"./pages/mobile/announcement/AnnouncementDetail.vue": 74307,
	"./pages/mobile/announcement/AnnouncementList": 90544,
	"./pages/mobile/announcement/AnnouncementList.vue": 90544,
	"./pages/mobile/home": 43724,
	"./pages/mobile/home.vue": 43724,
	"./pages/mobile/payment/StandardPayment": 86828,
	"./pages/mobile/payment/StandardPayment.vue": 86828,
	"./pages/mobile/payment/components/TopHoverView": 31973,
	"./pages/mobile/payment/components/TopHoverView.vue": 31973,
	"./pages/mobile/payment/components/UseGuideView": 80735,
	"./pages/mobile/payment/components/UseGuideView.vue": 80735,
	"./pages/mobile/solutions/AccountManagement": 26575,
	"./pages/mobile/solutions/AccountManagement.vue": 26575,
	"./pages/mobile/solutions/ElectronicCommerce": 16665,
	"./pages/mobile/solutions/ElectronicCommerce.vue": 16665,
	"./pages/mobile/solutions/FundPayment": 29590,
	"./pages/mobile/solutions/FundPayment.vue": 29590,
	"./pages/mobile/solutions/InternetFinance": 90131,
	"./pages/mobile/solutions/InternetFinance.vue": 90131,
	"./pages/productCenter/AccountHubPlatform": 89827,
	"./pages/productCenter/AccountHubPlatform.vue": 89827,
	"./pages/productCenter/AccountServices": 69413,
	"./pages/productCenter/AccountServices.vue": 69413,
	"./pages/productCenter/StandardPayment": 81415,
	"./pages/productCenter/StandardPayment.vue": 81415,
	"./pages/productCenter/components/AccountCard": 1657,
	"./pages/productCenter/components/AccountCard.vue": 1657,
	"./pages/productCenter/components/PaymentCard": 58385,
	"./pages/productCenter/components/PaymentCard.vue": 58385,
	"./pages/solutions/AccountManagement": 60869,
	"./pages/solutions/AccountManagement.vue": 60869,
	"./pages/solutions/ElectronicCommerce": 20453,
	"./pages/solutions/ElectronicCommerce.vue": 20453,
	"./pages/solutions/FundPayment": 35623,
	"./pages/solutions/FundPayment.vue": 35623,
	"./pages/solutions/InternetFinance": 13789,
	"./pages/solutions/InternetFinance.vue": 13789,
	"./pages/solutions/components/SolutionCard": 12878,
	"./pages/solutions/components/SolutionCard.vue": 12878,
	"./pages/solutions/components/SolutionIntroduction": 99367,
	"./pages/solutions/components/SolutionIntroduction.vue": 99367,
	"./router": 1120,
	"./router/": 1120,
	"./router/announcements": 87309,
	"./router/announcements.js": 87309,
	"./router/index": 1120,
	"./router/index.js": 1120,
	"./router/mobile": 80467,
	"./router/mobile.js": 80467,
	"./router/productCenter": 3025,
	"./router/productCenter.js": 3025,
	"./router/solutions": 12952,
	"./router/solutions.js": 12952,
	"./stores": 58326,
	"./stores/": 58326,
	"./stores/index": 58326,
	"./stores/index.js": 58326,
	"./util/aos-constants": 73009,
	"./util/aos-constants.js": 73009,
	"./util/enum": 6653,
	"./util/enum.js": 6653,
	"./util/tool": 38719,
	"./util/tool.js": 38719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;